export default __webpack_public_path__ + "static/media/disconnect-wallet.088716aa.svg";